import {
  LEAVE_CONFIRM_EDIT_ROUTES,
} from '../consts/LeaveConfirmEditRoute'

export default {
  data() {
    return {
      message: '編集中の情報が破棄されてしまいますが、よろしいですか？',
      isChenged: false,
    }
  },

  computed: {
    isLeaveConfirm() {
      return this.isChenged
        && (LEAVE_CONFIRM_EDIT_ROUTES.find(
          (route) => route.name === this.$route.name,
        ) !== undefined)
    },
  },

  mounted() {
    window.addEventListener('beforeunload', this.confirmSave)
  },

  methods: {
    fetchIsChanged(val) {
      this.isChenged = val
    },
    confirmSave(e) {
      if (this.isLeaveConfirm) {
        e.returnValue = this.message
      }
    },
  },

  beforeRouteLeave(to, from, next) {
    const toRoute = LEAVE_CONFIRM_EDIT_ROUTES.find((route) => route.name === to.name)
    const fromRoute = LEAVE_CONFIRM_EDIT_ROUTES.find((route) => route.name === from.name)

    if (!this.isChenged && (toRoute === undefined) && fromRoute?.completed) {
      next()
      return
    }

    if (!this.isLeaveConfirm || ((fromRoute?.step + 1) === toRoute?.step)
    ) {
      next()
      return
    }

    const checkLeave = window.confirm(this.message) // eslint-disable-line no-alert

    if (checkLeave) {
      next()
    } else {
      next(false)
    }
  },
}
